import type { FaireProductEntity } from "../../entity_types/product";

export const p_6sj94rmny3: FaireProductEntity = {
  token: "p_6sj94rmny3",
  type: "product",
  name: "Cheese Squishy Toy – Super Soft Sensory Cube MSS3",
  brandToken: "b_yffkzrfy9m",
  brandName: "Modek Sports",
  imageUrl:
    "https://cdn.faire.com/fastly/0d1fa614ee08be59914c0a513b703ae516eb72ae190ae78e3db17bf490541f02.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1f93afaa9e1edd3c78de1f8aced7870445df9264e53294edf7fb094f68fc175e.png",
  ],
  priceDollars: 4.5,
  description:
    'Cheese Squishy Toy – Super Soft Sensory Cube (2.75")\n\n\n\n\nAdd a fun and playful novelty item to your toy assortment with the Cheese Squishy Toy. Designed to look like a realistic block of cheese, this soft sensory squishy delivers a satisfying squeeze and slow-rise feel that customers love.\n\n\n\n\nIts bright yellow color and eye-catching cheese design make it a standout item for shelves, displays, and impulse purchases. Perfect for stress relief, fidget play, and sensory fun for both kids and adults.\n\n\n\n\nProduct Features:\n• Realistic cheese block design\n• Soft slow-rise squishy material\n• Fun sensory squeeze texture\n• Bright eye-catching yellow color\n• Great for stress relief and fidget play\n• Fun novelty and impulse buy item\n• Perfect for toy stores, gift shops, arcades, beach shops, and prize counters\n\n\n\n\nPackaging:\n• Individually wrapped\n• Comes in a colorful retail display box\n• Ideal for countertop merchandising and impulse sales\n\n\n\n\nA trendy novelty toy that combines sensory play, fun design, and strong visual appeal, making it a standout seller for a wide range of retail environments.\n',
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:36.764Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
